/**
 * PrideHub läuft in genau einer Zeitzone. Sie wird im Backend über die Umgebungsvariable
 * `PRIDEHUB_TIMEZONE` gesetzt und kommt mit `/meta` in die Apps mit Login.
 *
 * Dieser Wert ist der Fallback für die Zeit vor dem ersten `/meta`-Aufruf. Die öffentliche Website
 * kennt nur öffentliche Endpunkte und damit die Zone nicht zur Laufzeit; sie nutzt diesen Wert
 * deshalb direkt.
 */
export const DEFAULT_APP_TIME_ZONE = 'Europe/Berlin';

/** Das heutige Datum (`YYYY-MM-DD`) in der Zone der App – zum Vergleich mit Datumsfeldern aus dem Backend. */
export function todayIn(timeZone: string, now: Date = new Date()): string {
    return new Intl.DateTimeFormat('en-CA', { timeZone }).format(now);
}
